import { theme } from '@orobix/orobix-fe-components'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles((t: typeof theme) => ({
  scrollContainer: {
    height: 'calc(100vh - 150px)',
    overflowY: 'auto',
    '& thead th': {
      position: 'sticky',
      top: 0,
      backgroundColor: t.white,
      zIndex: 10,
    },
    '& tbody tr': {
      cursor: 'default',
    },
    '& tbody tr.selectable': {
      cursor: 'pointer',
    },
    '& tbody tr.selectable:hover': {
      backgroundColor: '#f5f5f5',
    },
  },
}))

export { useStyles }
